import { RawNodeDatum, TreeNodeDatum } from 'react-d3-tree'
import { SignalGroupVerdict } from './signal-group'

export enum NodeType {
  process = 'process',
  file = 'file',
  network = 'network',
  script = 'script',
  execute = 'execute',
  other = 'other',
}

export enum OverviewNodeType {
  Process = 'process',
  Network = 'network',
  Other = 'other',
}

export type TreeNode = {
  id: string
  parent: string
  type: NodeType
  action: string
  interesting: boolean
  source: string
  extra: { [key: string]: string }
  original: { [key: string]: any }
  childs: TreeNode[]
  verdictInfo?: SignalGroupVerdict
}

export type Rect = {
  x: number
  y: number
  width: number
  height: number
}

export type RawNodeDatumWithVerdict = RawNodeDatum & { verdictInfo?: SignalGroupVerdict }

export type TreeNodeDatumWithVerdict = TreeNodeDatum & { verdictInfo?: SignalGroupVerdict }
